<script>
    import { createEventDispatcher } from "svelte";
    import Button from "./Button.svelte";
    export let content = "",
        isEditing = false,
        isDeletable = false,
        data = {},
        extra = "",
        classNames = "";
    // idea being we load content from server, editedContent stores edit-in-progress
    // reconciled with stored content on save or used to revert to original if editing
    // has been canceled.
    let editedContent = content;
    let isDeleting = false;

    const dispatch = createEventDispatcher();

    const deleteRow = () => {
        dispatch("message", {
            action: "DELETE",
            data: {
                device_id: data.device_id,
            },
        });
    };

    const saveEditedContent = () => {
        if (content !== editedContent) {
            // only update if actual change
            content = editedContent;
            dispatch("message", {
                action: "UPDATE",
                data: {
                    device_id: data.device_id,
                    name: content,
                },
            });
        }
        isEditing = false;
    };
    import { t } from "../i18n";

</script>

<!--src/components/EditableTextRow.svelte-->
<div class="row {classNames} container flex-1 align-items-center justify-content-center">
    {#if isEditing}
        <input bind:value="{editedContent}" type="text" aria-label="Edit" />
    {:else if isDeleting}
        <div class="row">
            <div class="row content justify-content-space-between align-items-center">
                <div>{$t('remove_device', {"$replace$": content})}</div>
                <Button
                    on:click="{() => (isDeleting = false)}"
                    classNames="{'secondary dark'}"
                    buttonText="{$t('no_cancel')}"
                    flex="{'0 1 200px'}"
                />
                <Button
                    on:click="{() => deleteRow()}"
                    buttonText="{$t('yes_remove')}"
                    flex="{'0 1 200px'}"
                />
            </div>
            <div class="row" style="margin:16px 0px;">
                {$t('removal_explain')}
            </div>
        </div>
    {:else}
        <div class="flex-1 content">
            {content}
            <div class="flex-1">
                <em>{extra}</em>
            </div>
        </div>
    {/if}
    <div class="trailing">
        {#if isEditing}
            <i class="material-icons" on:click="{() => saveEditedContent()}">check</i>
            <i
                class="material-icons"
                on:click="{() => {
                    editedContent = content;
                    isEditing = false;
                }}"
            >
                clear
            </i>
        {:else if !isDeleting}
            <i
                class="material-icons"
                on:click="{() => {
                    editedContent = content;
                    isEditing = true;
                }}"
            >
                create
            </i>
            {#if isDeletable}
                <i class="material-icons-outlined" on:click="{() => (isDeleting = !isDeleting)}">delete</i>
            {/if}
        {/if}
    </div>
</div>

<style>
    div.content {
        color: var(--textColorDarkest);
        font-weight: 400;
    }
    .container {
        min-height: 42px;
        font-size: 16px;
        padding-bottom: 16px;
    }

    input {
        flex: 2;
    }
    .trailing {
        margin-left: auto;
        flex: 0 1 auto;
        cursor: pointer;
        min-width: 64px;
        justify-content: space-between;
        display: flex;
    }
    .trailing i {
        /* 44px height/width min reccomended touch targets by Apple */
        height: 44px;
        width: 44px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .no-touch .trailing i:hover {
        color: var(--primaryColor);
    }
</style>
